import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import{ getConditionalRowStyles, customExpandableIcon, RowsPerPageSelector, SearchTable, DataTable,customDataTableStyles } from './../../common/helper/table-imports.js';  

import NotificationsService from '../../../services/notification-service.js';

const Notification = () => { 
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [notificationData , setNotificationData] = useState([]);

  const [dataTableKey, setDataTableKey] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pageNo, setPageNo] = useState(0);

  const [totalRows, setTotalRows] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterData, setFilterData] = useState({
    paymentType: '',
    start_date: '',
    end_date: '',
  });
  const paginationComponentOptions = { 
    noRowsPerPage :true
  }
  const [columns, setColumns] = useState([
    
    {
      name: 'Payment Type',
      selector: row => <>
      <div style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }}><i className="fa fa-money me-1" style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }} />
      {row.transaction_type.toLowerCase().charAt(0).toUpperCase() + row.transaction_type.toLowerCase().slice(1)}
      </div>
      </>,
      sortable: true,
    },
    {
        name: 'Order ID',
        selector: row => row.order_code,
        sortable: true,
      },
    {
      name: 'Transaction Amount',
      selector: row => '₹' + row.amount,
      sortable: true,
    },     
    {
      name: 'Transaction Time',
      selector: row => row.created_on,
      sortable: true,
    }
  
  ]);

const handleRowsPerPageChange = (e) => {
  let rowsPage = Number(e.target.value)
  setRowsPerPage(rowsPage);
  setDataTableKey(prevKey => prevKey + 1);
  listNotifcations(false,pageNo, rowsPage)
};

  const listNotifcations = (fiterReset = false, pageNumber, rowsPage) => {
    setLoading(true);

    NotificationsService.getNotifications(fiterReset ? {} : filterData, pageNumber, rowsPage)
    .then(response => {
      const records = response.data.data.list;
      console.log(records.total_records)
      setTotalRows(response.data.data.total_records)
      setNotificationData(records)
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      try {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      } catch (e){
        toast.error( MESSAGES.SERVER_ERROR)
      }
    });
  }
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  };
  const filteredData = notificationData.filter((row) =>
  Object.values(row).some(
    (value) =>
      new RegExp(escapeRegExp(searchTerm), 'i').test(value)
  )
    );

  useEffect(() => {
    listNotifcations(false,0,10)
    document.body.style.backgroundImage = '';

    document.body.style.backgroundColor = '#f0f6fa';
    return () => {
      document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
}, []);
const handleChange = (e) => {
    const { name, value } = e.target;
  setFilterData((prevData) => ({ ...prevData, [name]: value }));

};
const applyFilter = () => {
 
  listNotifcations(false, pageNo, rowsPerPage);
}

const cancelFilter = () => {
    setFilterData({
        paymentType: '',
        start_date: '',
        end_date: ''
    })
    setPageNo(0)
 listNotifcations(true,0,rowsPerPage);
}
const handlePageChange = page => {
  let pageNumber = page - 1;
  setPageNo(pageNumber)
  listNotifcations(false, pageNumber, rowsPerPage);
};


    return(

      <>
        <LoaderOverlay loading={loading} />
   
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 className="updatename updatename1" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Notification List</h4>
        <div className="container" style={{backgroundColor: 'white'}}>
     
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button className="nav-link tbbtn active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Notification</button>
              
            </div>
          </nav>
          
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px', paddingBottom: '15px'}}>
            <div className="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <main>
                <div className style={{paddingBottom: '30px'}}>
                  <div className style={{backgroundColor: 'white'}}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                      <div className="col-md-12" style={{textAlign: 'right'}}>
                     
      </div>
                        <div id="examplemgmwallet_wrapper" className="dataTables_wrapper dt-jqueryui no-footer">
                        <div className="filterBtn">
                        
                        <div id="examplemgm_filter" className="dataTables_filter"><label><input type="search"    onChange={handleSearchChange} className placeholder="Search..."  
                        aria-controls="examplemgm" /></label></div>
                         <div>
        <a style={{marginRight: '10px'}} className="dropdown-toggle noapply show" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="true">
          <button style={{backgroundColor: 'white !important', color: 'black !important', border: '1px solid #e5e5e5', padding: '3px 10px', borderRadius: '5px', marginTop:'3px', marginBottom: '10px', fontSize: '13px'}} type="button" name="btn_login_details" className="btn">
            <i style={{color: 'black'}} className="fa fa-filter" aria-hidden="true" /> Filter 
          </button>
        </a>
        <a style={{marginRight: '10px', display: 'none'}} className="dropdown-toggle sebtnapply" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <button style={{backgroundColor: 'white !important', color: 'black !important', border: '1px solid #6ec531', padding: '3px 10px', borderRadius: '5px', marginBottom: '10px', fontSize: '13px'}} type="button" name="btn_login_details" className="btn sebtn">
            <i style={{color: '#6ec531'}} className="fa fa-check" aria-hidden="true" /> Filter 
          </button>
        </a>
        <div className="row dropdown-menu dropdown-menu-endd mbv" id="nvb" aria-labelledby="navbarDropdown" style={{display: 'none', position: 'absolute', inset: '0px auto auto 0px', margin: '0px', transform: 'translate3d(43.5556px, 150.222px, 0px)'}} data-popper-placement="bottom-start">
          <div className="col-md-12">
            <h5 className="daterange">Filter</h5>
            <h5 className="sdfgt">Date range</h5>
            <div className="col-md-6" style={{paddingRight: '5px'}}>
              <label style={{fontSize: '13px !important', fontWeight: 'bold !important', color: 'black !important', marginBottom: '5px'}} htmlFor="start_date">From :</label>
              <br />
              <input type="date" value={filterData.start_date} onChange={handleChange} className="form-control" id="start_date" name="start_date" required />
            </div>
            <div className="col-md-6" style={{paddingLeft: '5px'}}>
              <label style={{fontSize: '13px !important', fontWeight: 'bold !important', color: 'black !important', marginBottom: '5px'}} htmlFor="end_date">To :</label>
              <br />
              <input type="date" value={filterData.end_date} onChange={handleChange} className="form-control" id="end_date" name="end_date" required />
            </div>
          
            <div className="col-md-12" style={{paddingRight: '5px'}}>
              <div className="form-group frm" style={{textAlign: 'left', marginBottom: '0px'}}>
                <label className htmlFor="Industry">Payment Type</label>
                <select onChange={handleChange} value={filterData.paymentType} name="paymentType" className="drp" id="profiles_gender" style={{fontSize: '13px'}}>
                  <option value>Select Payment Type</option>
                  <option value="Payin">Payin</option>
                  <option value="Payout">Payout</option>
                </select>
              </div>
            </div>
            {/* <div className="col-md-12" style={{paddingRight: '5px'}}>
              <div className="form-group frm" style={{textAlign: 'left', marginBottom: '0px !important'}}>
                <label className htmlFor="Industry">Payment Method</label>
                <select name="gender" className="drp" id="profiles_gender" style={{fontSize: '13px'}}>
                  <option value>Select Payment Method</option>
                  <option value="UPI">UPI</option>
                  <option value="QR Code">QR Code</option>
                  <option value="Wallet">Wallet</option>
                </select>
              </div>
            </div> */}
            {/* <div className="col-md-12" style={{paddingRight: '5px'}}>
              <div className="form-group frm" style={{textAlign: 'left', marginBottom: '0px !important'}}>
                <label className htmlFor="Industry">Payment Status</label>
                <select name="gender" className="drp" id="profiles_gender" style={{fontSize: '13px'}}>
                  <option value>Select Payment Status</option>
                  <option value="Active">Active</option>
                  <option value="Pending">Pending</option>
                  <option value="Rejected">Rejected</option>
                  <option value="Suspended">Suspended</option>
                  <option value="Deleted">Deleted</option>
                </select>
              </div>
            </div> */}
            <div className="col-md-12" style={{textAlign: 'right', marginTop: '10px', borderTop: '1px solid #dde0e5'}}>
              <button style={{backgroundColor: 'white', color: 'black', border: '1px solid black', padding: '3px 10px', fontSize:'13px'}} onClick={cancelFilter} type="button" name="btn_login_details" className="btn sebtn" id="cancel_filter">Cancel</button>
              <button style={{padding: '3px 10px', marginLeft:'5px'}} type="submit" name="btn_login_details" id="date_filter" className="btn ddfg sebtn" onClick={applyFilter}>Apply</button>
            </div>
          </div>
        </div>
      </div>
                       
                  </div>

                    <div className="dataTables_length" id="examplemgm_length">
                                    <label>Show &nbsp;</label>
                     <select value={rowsPerPage} name="examplemgm_length" onChange={handleRowsPerPageChange}>
                       
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      &nbsp;entries
                    </div>
                        
                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={filteredData}
                              pagination
                              paginationPerPage={rowsPerPage} 
                              paginationComponentOptions={paginationComponentOptions} 
                              paginationServer
                              paginationTotalRows={totalRows}
                              onChangePage={handlePageChange}
                              customStyles={customDataTableStyles}
                        />
                        

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
            {/* <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
              <main>
                <div className style={{paddingBottom: '30px'}}>
                  <div className style={{backgroundColor: 'white'}}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                        <div id="examplemgm_wrapper" className="dataTables_wrapper dt-jqueryui no-footer">

                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={transaction.completedTransactions}
                              pagination
                              

                        />


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div> */}
          </div>
        </div>
      </div>
      </>
    )
}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(Notification));